import React from 'react';
import { InputProps } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface CustomInputTextProps extends InputProps {
	placeholder?: string;
}

export default function InputText({ placeholder = '', ...props }: Readonly<CustomInputTextProps>): JSX.Element {
	return <S.InputWrapper {...props} placeholder={I18n.get(placeholder)} />;
}
